import { computed, unref } from 'vue-demi'
import i18n from '@/utils/i18n'
import { useStoreGetters } from '../index'

export const useActiveRegionOpts = () => {
  const { activeRegions } = useStoreGetters('regions', ['activeRegions'])
  return computed(() => {
    return unref(activeRegions).map(item => {
      return Object.assign({}, item, {
        key: item.name,
        get name () {
          return i18n.te(`regionOptions.${item.name}`) ? i18n.t(`regionOptions.${item.name}`) : item.displayName
        },
        get value () { return item.name },
      })
    })
  })
}
